

import React, { useContext, useEffect, useState } from 'react'

import Paginator from '../../components/ui/Paginator';

import 'bootstrap-daterangepicker/daterangepicker.css';

import { Bank } from '../../models/interfaces';
import { useNavigate } from "react-router-dom";
import { BanksContext } from '../../context/bank/BankContext';




export const BanksPage = () => {
    const [buscar, setBuscar] = useState('');
    const [pageActual, setPageActual] = useState<number>(1);
    const { banks, totalPage, loadBanks, deleteBank } = useContext(BanksContext);
    const navigate = useNavigate();

    useEffect(() => {
        loadBanks(pageActual - 1);
    }, [pageActual])


    const filteredData = banks.filter((bank) =>
        bank.name.toString().toLowerCase().includes(buscar.toLowerCase())
    );

    const handleNew = () => {
        navigate("/bank");
    }

    const handleEdit = (bank: Bank) => {
        navigate("/bank", { state: { bank } });
    }

    const handleDelete = async (bank_id) => {

        const resp = await deleteBank(bank_id);
        if (resp !== "success") {
            alert(resp);
        }
    }


    return (

        <div className='mt-5 container' style={styles.container}>


            <div className="row justify-content-end mt-5">
                <div className=' col-md-3' style={{ position: 'revert' }}>
                    <input className="form-control" id="search" type="text" placeholder="Buscar" value={buscar} onChange={(e) => setBuscar(e.target.value)} />

                </div>
                {/* <div className=' col-md-1' style={{ position: 'revert' }}>
                    <button type="button" className="btn btn-success" onClick={handleNew}>Nuevo</button>
                </div> */}
            </div>
            <br></br>
            <table id='transactionTable' className="table table-hover table-striped">
                <thead className="thead-dark">
                    <tr>
                        <th>País</th>
                        <th>Nombre</th>
                        <th>Código</th>
                        {/* <th>Correo contacto</th>
                        <th>Teléfono contacto</th> */}
                        <th style={{ textAlign: 'center' }}>Acciones</th>

                    </tr>
                </thead>
                <tbody >
                    {
                        filteredData.length > 0
                            ?
                            filteredData.map(bank => (
                                <tr key={bank.id}>
                                    <td>{bank.country_code}</td>
                                    <td>{bank.name}</td>
                                    <td>{bank.code} </td>
                                    {/* <td>{bank.emails}</td>
                            <td>{bank.phones}</td> */}
                                    <td style={{ textAlign: 'center' }}>
                                        <button type="button" className="btn btn-primary" onClick={() => handleEdit(bank)}> <i className="bi bi-pencil"></i></button>

                                        <button type="button" className="btn btn-danger" style={{ marginLeft: '10px' }} onClick={() => handleDelete(bank.id)}><i className="bi bi-trash"></i></button>
                                    </td>
                                </tr>
                            ))
                            :
                            <tr> <td colSpan={7} className='text-center'>No existen bancos.</td></tr>
                    }


                </tbody>
            </table>

            {
                totalPage > 1 ? <Paginator totalPage={totalPage} pageActual={pageActual} onChange={(actual) => setPageActual(actual)} /> : <div />
            }
        </div>
    )
}


const styles = {
    container: {
        flex: 1,
        marginTop: 10,
        marginHorizontal: 20
    }
};
